import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CommonStyle from "../Styles/Common.module.css";
import ButtonStyle from "../Styles/Button.module.css";
import { BsArrowRightCircle } from "react-icons/bs";
import { getLocationDetail, getCategoryId } from "../../services/routes.services";
import { Spinners } from "../Common/Common/Loader";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const Search = ({ parentCallback, closeSearch }) => {
  const [locationContent, setLocationContent] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [locationValue, setLocationValue] = useState("");
  const [categoryValue, setCategoryValue] = useState("");
  const [errors, setErrors] = useState({});
  const [spinner, setSpinner] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getLocationDetail()
      .then((res) => {
        setLocationContent(res.data[0]?.location || []);
      })
      .catch((error) => {
        console.error("Failed to load locations:", error);
      });
  }, []);

  const handleLocation = (locationId) => {
    localStorage.setItem("SearchLocation", locationId);
    setLocationValue(locationId);
    setCategoryValue("");
    setCategoryList([]);

    getCategoryId(locationId)
      .then((res) => {
        const categoryData = res.data[0]?.category || [];
        setCategoryList(categoryData);
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
        setCategoryList([]);
      });
  };

  const handleCategory = (categoryId) => {
    localStorage.setItem("SearchCategory", categoryId);
    setCategoryValue(categoryId);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!locationValue) newErrors.locationValue = "Select a city";
    if (!categoryValue) newErrors.categoryValue = "Select a category";
    return newErrors;
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setSpinner(true);

    const newErrors = validateFields();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setSpinner(false);
      return;
    }

    const postData = {
      location: locationValue,
      category: categoryValue,
    };

    navigate("/searchResult");
    setSpinner(false);
    if (closeSearch) closeSearch();
  };
  //console.log("Selected value:", categoryValue);
  //console.log("Category list IDs:", categoryList.map((cat) => cat.id));
  return (
    <div>
      <div className={CommonStyle.HomeSearch}>
        <form className={CommonStyle.searchArea}>
          <div className={CommonStyle.FlexCol}>
            <FormControl>
              <InputLabel>Select City</InputLabel>
              <Select
                value={locationValue}
                onChange={(event) => handleLocation(event.target.value)}
              >
                {locationContent.map((city) => (
                  <MenuItem value={city.id} key={city.id}>
                    {city.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <span className={CommonStyle.fielsError}>{errors.locationValue}</span>
          </div>

          <div className={CommonStyle.FlexCol}>
            <FormControl>
              <InputLabel>What are you looking for?</InputLabel>
              <Select
                value={categoryValue}
                onChange={(event) => handleCategory(event.target.value)}
                disabled={!categoryList.length}
              >
                <MenuItem value="null">All</MenuItem>
                  {categoryList.map((category) => (
                  <MenuItem value={String(category.id)} key={category.id}>
                    {category.title}
                  </MenuItem>
                ))}
      
              </Select>
            </FormControl>
            <span className={CommonStyle.fielsError}>{errors.categoryValue}</span>
          </div>

          <div className={CommonStyle.submitArea}>
            <button
              onClick={handleSearch}
              type="button"
              className={`${ButtonStyle.defaultButton} ${ButtonStyle.roundStyle} ${ButtonStyle.orangeStyle}`}
            >
              Search <BsArrowRightCircle className={ButtonStyle.buttonArrow} />
            </button>
          </div>
        </form>
      </div>

      {spinner && <Spinners />}
    </div>
  );
};

export default Search;
